import { useParams } from "@tanstack/react-router";

import { TabsLayout } from "#layouts";

export const SettingsEntityView = () => {
	const params = useParams({ strict: false });
	const { entityName } = params as Record<string, string>;

	return (
		<TabsLayout
			key={entityName}
			entity={entityName}
			basePath={`/settings/${entityName}`}
			paramName="recordID"
			scope={`settings-${entityName}`}
		/>
	);
};
